import React, { ReactElement } from "react";
import shortid from "shortid";
import {
  info02,
  info02Cure,
  info02Rule,
  info02Symptom,
} from "../configs";

const Info02 = (): ReactElement => {
  return (
    <div className="skin-contents__inner">
      <div className="skin-contents__image--info">
        <h2 className="title">손발톱백선이란?</h2>

        {/** top */}
        <div className="skin-contents__image--top">
          {info02.map((item) => (
            <div
              className="image-contents title-contents"
              key={shortid.generate()}
            >
              <div className="title-contents__icon">
                <i className={`icon ${item.className}`} />
              </div>
              <strong className="info">{item.title}</strong>
              {item.info.split("\n").map((text) => (
                <p className="sub-info" key={shortid.generate()}>
                  {text}
                </p>
              ))}
            </div>
          ))}
        </div>

        {/** symptom */}
        <div className="skin-contents__image--symptom">
          <h2 className="title">증상</h2>
          <div className="image-text__inner">
            {info02Symptom.map((item) => (
              <div className="image-text" key={shortid.generate()}>
                <p className="sub-info">{item.info}</p>
              </div>
            ))}
          </div>
        </div>

        {/** cure */}
        <div className="skin-contents__image--cure">
          <h2 className="title">치료</h2>
          <div className="cure-bg" />
          <div className="image-text__inner">
            {info02Cure.map((item) => (
              <div className="image-text" key={shortid.generate()}>
                <strong className="info">{item.title}</strong>
                <p className="sub-info">{item.info}</p>
              </div>
            ))}
          </div>
        </div>

        {/** rule */}
        <div className="skin-contents__image--rule">
          <h2 className="title">생활수칙</h2>
          <div className="rule-bg" />
          <div className="image-text__inner">
            {info02Rule.map((item) => (
              <div className="rule-text" key={shortid.generate()}>
                {item.info.split("\n").map((text) => (
                  <p className="sub-info" key={shortid.generate()}>
                    {text}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Info02;
